import React,{usesEffect}  from 'react'
import { Portal } from "./../module/portal";
import { JobMonitoring } from "./../module/job-monitoring";
import { JobExecutionPlan,AddExecutionPlan,PlanHistory,Reprocess,ReprocessList,DailyPlanStatus } from "./../module/job-execution-plan";
import { SourceBI,Splunk,T1T2,Postpaid,Prepaid ,Refill,Usage} from "./../module/report";
import { SystemConfig } from "./../module/system-config";
import { UserMaintenance } from "./../module/user-maintenace"
import { RoleMaintenance } from "../module/role-maintenance"
import { JobTypeMaster } from "./../module/job-type-master"
import { ImportExport } from "./../module/import-export"
import { JobMaster } from "./../module/job-master";
import { ODSInventory , InventoryReport, OutboundInventory  } from "./../module/inventory";
import BannerMaster from "../module/master/banner-master";
import {RouteLayout,RouteLayout2} from "./../template/RouteLayout";
import * as api from "./../module/portal/api";
import { MergeArrayByKey } from "./../utils/common-function";
const route = [
    {
        path:'/'
        ,component :Portal 
    },
    {
        path:'/a'
        ,component :Portal 
    },
]
export const route2 = [
    {
        path:'/Job-Monitoring'
        ,component :JobMonitoring
        ,ScreenName:'Job Status History'  //ScreenName Must Equal Module Name in SqlDB
        ,HELPER_NAME:'JobStatusHistory'
    }, 
    {
        path:'/Job-Execution-Plan'
        ,component :JobExecutionPlan
        ,ScreenName:'Execution Plan' 
        ,HELPER_NAME:'ExecutionPlan'
    },
    {
        path:'/Execution-Plan'
        ,component :AddExecutionPlan
        ,ScreenName:'Add Job ExecutionPlan' 
        ,HELPER_NAME:'EditExecutionPlan'
    },
    {
        path:'/Daily-Plan-status'
        ,component :DailyPlanStatus
        ,ScreenName:'Daily Plan Status' 
        ,HELPER_NAME:'DailyPlanStatus'
    },
    {
        path:'/Execution-Plan-History'
        ,component :PlanHistory
        ,ScreenName:'Plan Status History' 
        ,HELPER_NAME:'PlanStatusHistory'
    },
    {
        path:'/System-Config'
        ,component :SystemConfig
        ,ScreenName:'System Configuration' 
        ,HELPER_NAME:'SystemConfiguration'
    },
    {
        path:'/Reprocess'
        ,component :Reprocess
        ,ScreenName:'Reprocess' 
        ,HELPER_NAME:'Reprocess'
    },
    {
        path:'/ReprocessList'
        ,component :ReprocessList
        ,ScreenName:'Reprocess List' 
        ,HELPER_NAME:'ReprocessList'
    },
    {
        path:'/User-Maintenance'
        ,component :UserMaintenance
        ,ScreenName:'User Maintenance' 
        ,HELPER_NAME:'UserMaintenance'
    },
    {
        path:'/Role-Maintenance'
        ,component :RoleMaintenance
        ,ScreenName:'Role Maintenance' 
        ,HELPER_NAME:'RoleMaintenance'
    },
    {
        path:'/Jop-Type-Master'
        ,component :JobTypeMaster
        ,ScreenName:'Job Type Master' 
        ,HELPER_NAME:'JobTypeMaster'
    },
    {
        path:'/Import-Export'
        ,component :ImportExport
        ,ScreenName:'Import Export' 
        ,HELPER_NAME:'ImportExport'
    },
    {
        path:'/Job-Master'
        ,component :JobMaster
        ,ScreenName:'Job Master' 
        ,HELPER_NAME:'JobMaster'
    },
    {
        path:'/ODS-Inventory'
        ,component :ODSInventory
        ,ScreenName:'ODS Inventory' 
        ,HELPER_NAME:'ODSInventory'
    },
    {
        path:'/Inventory-Report'
        ,component :InventoryReport
        ,ScreenName:'Inventory Report' 
        ,HELPER_NAME:'InventoryReport'
    },
    {
        path:'/Outbound-Inventory'
        ,component :OutboundInventory
        ,ScreenName:'Outbound Inventory' 
        ,HELPER_NAME:'OutboundInventory'
    },
    {
        path:'/Report/SourceBI'
        ,component :SourceBI
        ,ScreenName:'Source-BI' 
        //,HELPER_NAME:'JobTypeMaster'
    },
    {
        path:'/Report/Splunk'
        ,component :Splunk
        ,ScreenName:'Splunk' 
        //,HELPER_NAME:'JobTypeMaster'
    },
    {
        path:'/Report/t1t2'
        ,component :T1T2
        ,ScreenName:'t1t2' 
        //,HELPER_NAME:'JobTypeMaster'
    },
    {
        path:'/Report/postpaid'
        ,component :Postpaid
        ,ScreenName:'Postpaid' 
        //,HELPER_NAME:'JobTypeMaster'
    },
    {
        path:'/Report/prepaid'
        ,component :Prepaid
        ,ScreenName:'Prepaid' 
        //,HELPER_NAME:'JobTypeMaster'
    },
    {

        path:'/Report/refill'
        ,component :Refill
        ,ScreenName:'Refill' 
        //,HELPER_NAME:'JobTypeMaster'
    },
    {

        path:'/Report/usage'
        ,component :Usage
        ,ScreenName:'Usage' 
        //,HELPER_NAME:'JobTypeMaster'
    },
    {

        path:'/Master/Announcement'
        ,component :BannerMaster
        ,ScreenName:'Announcement' 
        //,HELPER_NAME:'JobTypeMaster'
    },
]


export const ProtectedRoutes = () => {
    //if(!CheckToken()){
//        history.replace('/Login')
//            let urlSaml = `${API_URL.Authen}/auth/Login?returnUrl=/`;
//            window.location.replace(urlSaml);
    //    return null;
    //}
    return (
        <>
            {route.map((el,idx)=>(
                    <RouteLayout key ={idx} exact path={el.path} component={el.component} />
            ))
            }
            {route2?.map((el,idx)=>(
                
                    <RouteLayout2 key={idx} exact path={el.path} component={el.component} ScreenName={el.ScreenName} helper={el.HELPER_NAME}/>
            ))
            }
        </>
    )
}
ProtectedRoutes.route = Object.values(route.concat(route2).map((el)=>el.path))
